<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <img src="static\img\icon.jpeg" width="100%"/>
        </div>
        <div class="col-md-8">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-body">  
                <h3 style="text-align:center">Update Password</h3>  
                <br>
                <form @submit.prevent="handleSubmit()">
                  <b-form-fieldset
                    label="Password Baru"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-input type="password" placeholder="New Password" name="password" v-validate="'required'" v-model="password" ref="password"></b-form-input>
                    <small class="text-danger" v-show="errors.has('password')">
                      {{ errors.first('password') }}
                    </small>                      
                  </b-form-fieldset>     
                  <b-form-fieldset
                    label="Konfirmasi Password"
                    :label-cols="3"
                    :horizontal="true">
                    <b-form-input type="password" placeholder="Konfirmasi Password" name="Konfirmasi Password" v-model="confirm" v-validate="'required|confirmed:password'"></b-form-input>
                    <small class="text-danger" v-show="errors.has('Konfirmasi Password')">
                      {{ errors.first('Konfirmasi Password') }}
                    </small>                      
                  </b-form-fieldset>                    
                  <!-- <b-button size="lg" type="submit" variant="primary">Primary</b-button>           -->
                  <div style="display:flex;justify-content:center;">
                  <vue-button-spinner class="btn" 
                  style="
                    background-color: #20a8d8;
                    color: white;
                    border-radius: 6px;
                    width:150px;
                    "
                    :is-loading="isLoading" 
                    :disabled="isLoading"
                    type="submit"
                    >
                    <span>Update Password</span>
                  </vue-button-spinner>                                   
                  </div>
                </form>
              </div>
            </div> 
          </div>    
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueButtonSpinner from 'vue-button-spinner'
import swal from 'sweetalert'

export default {
  data () {
    return {
      email: this.$route.params.token,
      isLoading: false,
      password: '',
      confirm: ''
    }
  },
  components: {
    VueButtonSpinner
  },
  methods: {
    handleSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isLoading = true
          var data = {
            token: this.$route.params.token,
            password: this.password
          }
          this.$http.post('resetpassword', data).then(() => {
            swal('Success', 'Password berhasil di-update', 'success')
            this.$router.push({ path: '../login' })
          }).catch(() => {
            this.isLoading = false
            swal('Gagal', 'Gagal meng-update password', 'error')
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/UpdatePassword.vue?c890ffee